import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v8';

import packageJson from '../package.json';
import { PrivateLayout, PublicLayout, RootLayout } from '@/layouts';
import { privateRoutes, publicRoutes } from '@/routing/Router';
import { AuthenticatedBoundary } from '@/routing/authenticated-boundary';
import { RouteProviders } from '@/routing/route-providers';
import { ApplicationProviders } from '@/shared/providers';
import { initializeMonitoring } from '@/shared/libs/monitoring.lib';

import '@/shared/styles/index.css';
import '@theguarantors/tg-package-material-ui/dist/fonts/index.css';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

rootElement.setAttribute('version', packageJson.version.substring(1));
initializeMonitoring();

const router = createBrowserRouter([
  {
    element: <RouteProviders />,
    children: [
      {
        element: <RootLayout />,
        children: [
          { element: <PublicLayout />, children: publicRoutes },
          {
            element: <AuthenticatedBoundary />,
            children: [{ element: <PrivateLayout />, children: privateRoutes }],
          },
        ],
      },
    ],
  },
]);

createRoot(rootElement).render(
  <React.StrictMode>
    <ApplicationProviders>
      <RouterProvider router={router} />
    </ApplicationProviders>
  </React.StrictMode>,
);
